
import { mapState } from 'vuex'
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },
    type: {
      type: Number,
      default: 0
    },
    domain: {
      type: String,
      default: ''
    }
  },
  data() {
    const _list = []
    this.data?.forEach((it, k) => {
      _list.push(it)
      _list[k].show = false
      _list[k].zk = false
      _list[k].zk_show = false
    })
    const _lan = this.$store.state.LanguageCode

    return {
      lan: _lan,
      islongLan: !'zh-cn,zh'.includes(_lan),
      list: _list,
      pageIndex: 0,
      showLoadMore: false,
      loadAll: false,
      pageSize: 6,
      device: 'pc'
    }
  },
  computed: {
    ...mapState({
      isMobile: 'mobile'
    }),
    isAr() {
      return this.$store.state.LanguageCode == 'ar'
    },
    GetItemWidth() {
      let wcls = ''
      if (this.list?.length == 1) {
        wcls += 'w-1120'
      } else {
        wcls += 'w-550'
      }

      if (this.list?.length == 1 || this.islongLan) {
        wcls += ' lg:w-860'
      } else {
        wcls += ' lg:w-420'
      }

      return wcls
    }
  },
  mounted() {
    const that = this
    that.DealShow()
    window.addEventListener('resize', () => {
      that.DealShow()
    })
    console.log('this.list', this.list)
  },
  methods: {
    // 检测文本中是否包含至少一个阿拉伯语字符
    isArabicText(text) {
      if(text){
        return /[\u0600-\u06FF]/.test(text)
      } else {
        return false
      }
    },
    getStockInfo(item, key) {
      if (key == 'stock') {
        if (item?.traderShortName && item?.stockcode) {
          return item?.traderShortName + (item?.stockcode ? ' (' + item?.stockcode + ')' : '')
        } else if (item?.traderShortName) {
          return item?.traderShortName
        } else if (item?.stockcode) {
          return item?.stockcode
        }
      } else if (key == 'exchange') {
        if (item?.listExchangeName && item?.listExchangeCode) {
          return item?.listExchangeName + (item?.listExchangeCode ? ' (' + item?.listExchangeCode + ')' : '')
        } else if (item?.listExchangeName) {
          return item?.listExchangeName
        } else if (item?.listExchangeCode) {
          return item?.listExchangeCode
        }
      }
    },
    LoadMorePage() {
      if (this.loadAll) {
        return false
        // this.pageIndex = 0
        // this.loadAll = false
        // this.$emit('sladeup')
      } else {
        this.pageIndex++
        if (this.list?.length <= this.pageIndex * 30) {
          this.loadAll = true
        } else {
          this.loadAll = false
        }
      }

      this.DealShow()
    },
    GetShiZhi(item, type) {
      if (item?.marketValue) {
        if (type == 1) {
          return (item?.symbol ? item?.symbol : '') + item?.marketValue
        } else if (type == 2) {
          return (item?.symbol ? item?.symbol : '') + item?.marketValue + (item?.unit ? ' ' + item?.unit : '')
        } else {
          return (item?.symbol ? item?.symbol : '') + item?.marketValue + (item?.unit ? item?.unit : '')
        }
      } else {
        return '--'
      }
    },
    // 是否显示加载更多 + 单项显示隐藏
    checkShow() {
      this.showLoadMore = this.list?.length > this.pageSize
    },
    changeZhanKai(k) {
      this.list[k].zk = !this.list[k].zk
    },
    DealShow() {
      this.DealClientWidth()
      if (this.pageIndex > 0) {
        this.list?.forEach((it, k) => {
          if (k < this.pageIndex * 30) {
            it.show = true
          } else {
            it.show = false
          }
        })
      } else {
        this.list?.forEach((it, k) => {
          if (k < this.pageSize) {
            it.show = true
          } else {
            it.show = false
          }
        })
      }
      this.checkShow()
    },
    DealClientWidth() {
      const clientWidth = document.documentElement.clientWidth + this.getScrollbarWidth()
      if (clientWidth >= 1200) {
        this.pageSize = 6
        this.device = 'pc'
      } else if (clientWidth >= 1000) {
        this.pageSize = this.islongLan ? 3 : 6
        this.device = 'lg'
      } else if (clientWidth >= 800) {
        this.pageSize = 3
        this.device = 'md'
      } else {
        this.pageSize = 3
        this.device = 'sm'
      }
    },
    getScrollbarWidth() {
      // 计算滚动条宽度
      const scrollDiv = document.createElement('div')
      scrollDiv.style.cssText = 'height: 99px; overflow: scroll; position: absolute; top: -9999px;'
      document.body.appendChild(scrollDiv)
      const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
      document.body.removeChild(scrollDiv)
      return scrollbarWidth
    }
  }
}
